<template>
  <Card padding-less outlined>
    <Row class="align-center px-9 py-4">
      <Col cols="12 col-md-8">
        <div class="d-flex flex-column-reverse flex-sm-row">
          <h4
            class="text-h4 font-weight-medium mr-2 mb-2 text-truncate"
            :style="titleMaxWidthStyle"
            v-text="domain.address"
          />
          <Tag
            :class="tagClass"
            :text="tagText"
            :outlined="tagOutlined"
            small
          />
        </div>
        <p :class="grayText" v-text="descriptionText" />
      </Col>
      <Col cols="12 col-sm-12 col-md-4">
        <Row class="justify-center justify-md-end">
          <SwitchButton v-if="domain.canBeSwitched" />
          <SetAsMainButton
            :disabled="actionsDisabled"
            @click="setAsMain"
            v-if="domain.canBeMain"
          />
          <ModalDeleteDomain
            :domainToRemove="domain"
            :temporaryDomain="temporaryDomain"
            @success="$emit('updateList')"
            v-if="domain.canBeDeleted"
          />
        </Row>
      </Col>
    </Row>
  </Card>
</template>
<script>

import { Card, Tag, Row, Col } from '@locaweb/design-system-vue'
import { update } from '@/api/domains.api'
import SwitchButton from './DomainCard/SwitchButton.vue'
import SetAsMainButton from './DomainCard/SetAsMainButton.vue'
import ModalDeleteDomain from './DomainCard/ModalDeleteDomain.vue'
import { NOTIFICATION_DEFAULTS } from '@/consts'

export default {
  name: 'DomainCard',
  components: {
    Row,
    Col,
    Tag,
    Card,
    SwitchButton,
    SetAsMainButton,
    ModalDeleteDomain
  },
  props: {
    domain: {
      type: Object,
      required: true
    },
    temporaryDomain: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      actionsDisabled: false
    }
  },
  computed: {
    lc () {
      return this.$lc('domains.manageDomain.domainCard')
    },
    tagText () {
      return this.lc.tagText[this.domain.status] || this.lc.tagText[this.domain.type]
    },
    tagClass () {
      const margin = 'ml-sm-1 ml-md-2'

      if (this.domain.hasError) {
        return `text-caption error error--text ${margin}`
      }

      if (this.domain.isMain) {
        return `text-caption gray scale300 gray--text text--scale600 font-weight-medium ${margin}`
      }

      return `shade-white ${this.grayText} ${margin}`
    },
    tagOutlined () {
      return !this.domain.isMain
    },
    descriptionText () {
      return this.lc.description[this.domain.status] || this.lc.description[this.domain.type]
    },
    grayText () {
      return 'text-caption gray--text text--scale500 font-weight-medium'
    },
    siteId () {
      // TODO: We need to change this in the future using
      // route guards and global state with pinia
      return this.$route.params.siteId
    },
    titleMaxWidthStyle () {
      return { maxWidth: '72%' }
    }
  },
  methods: {
    async setAsMain () {
      this.actionsDisabled = true

      try {
        await update(this.siteId, {
          ...this.domain,
          type: 'main'
        })

        this.$emit('updateList')

        this.$notify.show({ ...NOTIFICATION_DEFAULTS, message: this.lc.setAsMainButton.successNotification, state: 'success' })
      } catch {
        this.$notify.show({ ...NOTIFICATION_DEFAULTS, message: this.lc.setAsMainButton.failedNotification, state: 'error' })
      } finally {
        this.actionsDisabled = false
      }
    }
  }
}
</script>
